import React, { useState, useEffect, Suspense, lazy, useCallback } from "react";
import Select from "react-select";
import { DatePicker } from "reactstrap-date-picker";
import "./Master.css";
import { softwareOptions } from "content/static.js";
import { useDispatch, useSelector } from "react-redux";
import {
  commonDataAction,
  modelListAction,
  loadingMasterAction,
  downloadColumnNameAction,
} from "../../redux/actions/master.action.js";
import LoadingModel from "components/Event/LoadingModel";
import Loading from "components/Event/Loading";
import CommonAlert from "components/Alert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRotateRight, faFilter } from "@fortawesome/free-solid-svg-icons";
import DownloadExcelModal from "../../components/Model/ExportMasterExcel";
import { masterType } from "../../redux/type";
import FloatingFab from "components/Model/FloationFab";
import DynamicMasterTable from "./DynamicTable";
const Pagination = lazy(() => import("section/Pagination.js"));


const Data = () => {
  const [tbodyData, setTbodyData] = useState([]);
  const [query, setQuery] = useState("");
  const [originalTbodyData, setOriginalTbodyData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [modelData, setModelData] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [showExcelModal, setShowExcelModal] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});
  const [showCheckboxes, setShowCheckboxes] = useState(false);
  const [selectedDetailOption, setSelectedDetailOption] = useState({
    value: "NO",
    label: "without details",
  });
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [showModel, setShowModel] = useState(false);
  const optionsComponentDetails = [
    { value: "NO", label: "without details" },
    { value: "YES", label: "with details" },
  ];
  const [dataKeys, setDataKeys] = useState({});
  const [showFabOptions, setShowFabOptions] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [data, setData] = useState({
    fromDate: "",
    toDate: "",
    logFrom: "",
    software: { value: "EIS", label: "EIS" },
    model: "",
    findsubareaId: ""
  });

  const dataHandle = (name, value) => {
    let updatedValue;

    if (value === null || value === "") {
      updatedValue = "";
    } else if (name === "fromDate" || name === "toDate") {
      updatedValue = typeof value === "string" ? value.split("T")[0] : value;
    } else {
      updatedValue = value;
    }
    setData({ ...data, [name]: updatedValue });
  };

  const {
    modalList,
    commonData,
    column,
    pagination,
    isLoading,
    modalFilterData,
    model,
    error,
  } = useSelector((state) => state.master);



  const { user } = useSelector((state) => state.auth);
  const filterListData = modalFilterData ? Object.keys(modalFilterData) : [];

  const remove = ["_id", "SubareaId"];

  const filterList = filterListData.filter((list) => {
    if (user.role === "admin") {
      return !remove.includes(list);
    } else {
      return (
        !remove.includes(list) &&
        list.slice(-4) !== "Suid" &&
        list.slice(-4) !== "suid"
      );
    }
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (!modalList) {
      dispatch(modelListAction());
    }
  }, []);

  const setFromDatez = (date) => {
    setFromDate(date || "");
  };

  const setToDatez = (date) => {
    setToDate(date || "");
  };

  const handleSearchButtonClick = async () => {
    if (Object.keys(modelData || {}).length === 0) {
      setErrorMsg("Please Select Model");
      return;
    } else {
      setErrorMsg("");
    }

    const isFilterKeyEmpty = !dataKeys.keys || dataKeys.keys.trim() === "";

    const requestData = {
      ...data,
      page_no: 1,
      limit: pagination.limit,
      model: modelData.value,
      software: data.software?.value ? data.software.value : undefined,
      findsubareaId: data.findsubareaId,
      frontendFilter: isFilterKeyEmpty
        ? {}
        : {
          [dataKeys.keys]: dataKeys.value ?? "",
        },
    };



    dispatch(loadingMasterAction(true));

    dispatch(
      commonDataAction(
        requestData,
        1,
        pagination.limit,
        modelData.modelId,
        modelData,
        modalFilterData
      )
    );
  };

  const handleSearch = () => {
    if (!query.trim()) {
      setTbodyData(originalTbodyData);
    } else {
      const filteredData = originalTbodyData.filter((row) =>
        Object.values(row).some((field) =>
          String(field).toLowerCase().includes(query.toLowerCase())
        )
      );
      setTbodyData(filteredData);
    }
  };

  useEffect(() => {
    handleSearch();
  }, [query]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (modelData?.length === 0) {
      setModelData(model);
    };

  }, [data.software?.value, model, modelData?.length]);

  useEffect(() => {
    if (softwareOptions.length > 0 && !data.software?.value && data.software?.value !== "") {
      const defaultOption = softwareOptions.find(option => option.value === "EIS");
      if (defaultOption) {
        setData(prev => ({ ...prev, software: defaultOption }));
      }
    }
  }, [softwareOptions]);

  const handlePageClick = (page_no) => {
    const requestData = {
      ...data,
      page_no: page_no.selected + 1,
      limit: pagination.limit,
      model: modelData.value,
      findsubareaId: data.findsubareaId,
      frontendFilter: {
        [dataKeys.keys]: dataKeys.value,
      },
      software: data?.software?.value,
    };
    dispatch(loadingMasterAction(true));
    dispatch(
      commonDataAction(requestData, page_no.selected + 1, pagination.limit)
    );
  };

  useEffect(() => {
    if ((error && error.status === 400) || (error && error.status === 200)) {
      setShowError(true);

      // Hide the error message after 3 seconds (adjust the duration as needed)
      const timer = setTimeout(() => {
        setShowError(false);
      }, 4000);

      return () => clearTimeout(timer); // Clear the timer when the component unmounts or when error status changes
    }
  }, [error]);

  const handleClearFields = () => {
    const clearedData = {
      fromDate: "",
      toDate: "",
      logFrom: "",
      software: { value: "EIS", label: "EIS" },
      findsubareaId: "",
      frontendFilter: {}  // send empty object
    };

    // Reset keys and value to empty
    setDataKeys({
      keys: "",
      value: ""
    });

    setData(clearedData);

    const requestData = {
      ...clearedData,
      page_no: 1,
      limit: pagination.limit,
      model: modelData?.value || "",
      software: "EIS",
      findsubareaId: "",
      frontendFilter: {}  // ensure clean request
    };

    dispatch(
      commonDataAction(requestData, 1, pagination.limit, "", "", filterList)
    );
  };


  const handleShow = useCallback(() => {
    setShowExcelModal(true)
  }, [])

  const handleClose = () => {
    setSelectedKeys([]);
    setSearchValue("")
    setShowExcelModal(false);
    setShowCheckboxes(false);
    setSelectedDetailOption({ value: "NO", label: "without details" });
    dispatch({
      type: masterType.DOWNLOAD_EXCEL,
      payload: { data: "" },
    });
  };

  return (
    <>
      <LoadingModel show={isLoading} />
      {showError && (
        <CommonAlert
          variant={`${error?.status === 200 ? "success" : "danger"}`}
          key={`${error?.status === 200 ? "success" : "danger"}`}
          message={`${error?.status === 200 ? `${error?.message}` : `${error?.message}`
            }`}
          className={"alert-right"}
          showAlert={showError}
        // style={style}
        />
      )}
      <Suspense
        fallback={
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "100vh" }}
          >
            <Loading />
          </div>
        }
      >
        <div className="container-fluid">


          <div className="container-fluid">
            {/* First Row */}
            <div className="row mb-2">

              <div className="col-md-4  pl-3 pr-0 pb-0 pt-0">
                <div className="d-flex flex-column h-100">
                  <label className="mb-1 text-sm font-medium text-gray-700">Select Master *</label>
                  <Select
                    value={modelData || ""}
                    options={modalList}
                    onChange={(selectedOption) => {
                      setModelData(selectedOption);
                      setErrorMsg("");
                      setDataKeys({ keys: "", value: "" });
                    }}
                    className="w-100"
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: '40px',
                        borderColor: errorMsg ? 'red' : '#d1d5db',
                        boxShadow: errorMsg ? '0 0 0 1px red' : 'none',
                      }),
                    }}
                  />
                  {errorMsg && (
                    <p className="mt-1 text-xs text-red-600">{errorMsg}</p>
                  )}
                </div>
              </div>

              <div className="col-md-3">
                <div className="d-flex flex-column h-100">
                  <label className="mb-1 text-sm font-medium text-gray-700">Software</label>
                  <Select
                    options={softwareOptions}
                    value={data.software}
                    onChange={(software) => dataHandle("software", software)}
                    className="w-100"
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: '40.5px',
                      }),
                    }}
                  />
                </div>
              </div>


              <div className="col-md-3">
                <div className="d-flex flex-column h-100">
                  <label className="mb-1 text-sm font-medium text-gray-700">Subarea ID</label>
                  <input
                    value={data.findsubareaId || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "") {
                        setData({ ...data, findsubareaId: "" });
                        return;
                      }
                      if (!isNaN(value) && !isNaN(parseFloat(value))) {
                        setData({ ...data, findsubareaId: Number(value) });
                      } else {
                        alert("Please enter a valid number");
                      }
                    }}
                    type="text"
                    placeholder="Enter Subarea ID"
                    className="form-control"
                    style={{ height: '40px' }}
                  />
                </div>
              </div>

              <div className="col-md-2 pr-1">
                <div className="d-flex flex-column">
                  <label className="mb-1 text-sm font-medium text-gray-700 invisible">Actions</label>
                  <div className="button-container">
                    <button
                      className="btn btn-outline-secondary"
                      onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
                    >
                      <FontAwesomeIcon icon={faFilter} className="me-2" />

                    </button>
                    <button className="btn btn-warning" onClick={handleClearFields}>
                      <FontAwesomeIcon icon={faArrowRotateRight} />
                    </button>

                    <button className="btn btn-primary" onClick={handleSearchButtonClick}>
                      Search
                    </button>
                  </div>

                </div>
              </div>


            </div>

            <div className="table-controls" style={{ position: 'relative' }}>
              {/* Filter button that triggers the dropdown */}

              {/* Dropdown-style modal */}
              {showAdvancedFilters && (
                <div className="filter-dropdown">
                  <div className="filter-dropdown-content">
                    <div className="d-flex flex-column p-3 gap-3"> {/* Changed to flex-column and added gap */}

                      {/* Filter Key - Row 1 */}
                      <div className="w-100">
                        <div className="d-flex flex-column">
                          <label className="mb-1 text-sm font-medium text-gray-700">Filter Key</label>
                          <div className="position-relative">
                            <select
                              className="master-Filter-key w-100 px-3 text-sm rounded-md"
                              value={dataKeys.keys || ""}
                              onChange={(e) => setDataKeys(prevData => ({
                                ...prevData,
                                keys: e.target.value
                              }))}
                              style={{
                                height: '40px',
                                lineHeight: '1.5'
                              }}
                            >
                              <option value="">-- Select Key --</option>
                              {filterList.map((list, index) => (
                                <option key={index} value={list}>{list}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      {/* Filter Value - Row 2 */}
                      <div className="w-100">
                        <div className="d-flex flex-column">
                          <label className="mb-1 text-sm font-medium text-gray-700">Filter Value</label>
                          <input
                            value={dataKeys.value}
                            onChange={(e) => {
                              const rawValue = e.target.value.trim().toLowerCase();
                              setDataKeys((prevData) => ({
                                ...prevData,
                                value: rawValue === "true" ? true : rawValue === "false" ? false : e.target.value, // fallback if needed
                              }));
                            }}

                            style={{
                              height: '40px',
                              lineHeight: '1.5'
                            }}
                            type="text"
                            placeholder="Enter Value"
                            className="blue-border-input w-100 px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 min-h-[40px]"
                          />
                        </div>
                      </div>

                      {/* From Date - Row 3 */}
                      <div className="w-100" style={{ zIndex: 'auto' }}>
                        <div className="d-flex flex-column">
                          <label className="mb-1 text-sm font-medium text-gray-700">From Date</label>
                          <DatePicker
                            id="from-datepicker"
                            value={data.fromDate}
                            onChange={(date) => dataHandle("fromDate", date)}
                            placeholder="From"
                            className="form-control"
                            popperClassName="datepicker-popper"
                            popperPlacement="bottom-start"
                          />
                        </div>
                      </div>

                      {/* To Date - Row 4 */}
                      <div className="w-100" style={{ zIndex: 'auto' }}>
                        <div className="d-flex flex-column">
                          <label className="mb-1 text-sm font-medium text-gray-700">To Date</label>
                          <DatePicker
                            id="to-datepicker"
                            value={data.toDate}
                            onChange={(date) => dataHandle("toDate", date)}
                            placeholder="To"
                            className="form-control"
                            popperClassName="datepicker-popper"
                            popperPlacement="bottom-start"
                          />
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              )}

            </div>
          </div>


          <div className="row pr-1">
            {tbodyData.length > 0 && (
              <>
                <div className="col-md-3">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search"
                      onChange={(event) => {
                        setQuery(event.target.value);
                        handleSearch(); // Call handleSearch when the search input changes
                      }}
                    />
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="row pt-2 pl-3 justify-content-end pr-3">

            <>
              <DownloadExcelModal
                show={showExcelModal}
                handleClose={handleClose}
                commonData={commonData}
                data={model}
                componentOption={optionsComponentDetails}
                selectedDetailOption={selectedDetailOption}
                setSelectedDetailOption={setSelectedDetailOption}
                selectedKeys={selectedKeys}
                setSelectedKeys={setSelectedKeys}
                dataKeys={dataKeys}
                filterList={filterList?.[0]}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                searchData={data}
                showCheckboxes={showCheckboxes}
                setShowCheckboxes={setShowCheckboxes}
              />
            </>
          </div>

          <FloatingFab
            showFabOptions={showFabOptions}
            setShowFabOptions={setShowFabOptions}
            handleShow={handleShow}
            setShowModel={setShowModel}
            downloadColumnFile={() => { dispatch(downloadColumnNameAction(modelData, commonData)) }}
            user={user}
            dataHandle={dataHandle}
            commonData={commonData}
            modelData={modelData}
          />

          <div style={{ height: "75vh", overflowY: "auto", padding: '0px 15px' }}>
            <DynamicMasterTable
              expandedRows={expandedRows}
              setExpandedRows={setExpandedRows}
              array={commonData || []}
              path={[]}
              columns={column}
            />
          </div>

          <div className="mt-2">
            {commonData && (
              <Pagination
                data={data}
                modelId={modelData?.modelId}
                modelData={modelData}
                setModelData={setModelData}
                pagination={pagination}
                handlePageClick={handlePageClick}
                showModel={showModel}
                setShowModel={setShowModel}
                dataKeys={dataKeys}

              />
            )}
          </div>



        </div>
      </Suspense >
    </>
  );
};

export default Data;















